import { render, staticRenderFns } from "./MultiTaskPresets.vue?vue&type=template&id=67780e23&scoped=true&"
import script from "./MultiTaskPresets.vue?vue&type=script&lang=js&"
export * from "./MultiTaskPresets.vue?vue&type=script&lang=js&"
import style0 from "./MultiTaskPresets.vue?vue&type=style&index=0&id=67780e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67780e23",
  null
  
)

export default component.exports